
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/experiences",
      function () {
        return require("private-next-pages/[athleteSlug]/experiences.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/experiences"])
      });
    }
  